import { MouseEvent } from 'react';
import { Edge, ReactFlowInstance, XYPosition, getRectOfNodes } from "reactflow";
import { createTopicNodeTravellerEdge, createTravellerEdge } from '../../edges/traveller-edge/traveller-edge.helper';
import { uuid } from "../../utils";
import { ChatNodeData, TypeChatNode } from "./response-node.model";
import { scale, map } from "../../hooks/useMap";
import { BrainstormNodeData, TypeBrainstormNode } from '../brainstorm-node/brainstorm-node.model';

export const createChatNode = (
  reactFlowInstance: ReactFlowInstance,
  sourceId: string,
  data: ChatNodeData,
  isChild?: boolean,
) => {
  const currNode: TypeChatNode | undefined =
    reactFlowInstance.getNode(sourceId);
  if (!currNode) {
    return;
  }
  setTimeout(() => {
    let position: XYPosition;
    if (!isChild) {
      position = {
        x: currNode.position.x,
        y: currNode.position.y + 120,
      };
    } else {
      position = {
        x: (currNode.width ?? 0)/2,
        y: 120,
      };
    }
    const newNode: TypeChatNode = {
      id: `chat-${uuid()}`,
      type: 'chat',
      dragHandle: '.drag-handle',
      position,
      parentNode: isChild ? sourceId : undefined,
      data,
    };
    reactFlowInstance.addNodes(newNode);

    // add traveller edge
    const newEdge = createTopicNodeTravellerEdge(sourceId, newNode.id, false)
    reactFlowInstance.setEdges((edges) => edges.concat(newEdge));

    // increase z-index when first added so it shows up above existing nodes
    setTimeout(() => {
      const nodeElement = document.querySelectorAll(`[data-id="${newNode.id}"]`)[0];
      // @ts-ignore
      nodeElement.style.zIndex = '1';
    },300);

  }, 100);
};

export const createFollowUpChatNode = (
  reactFlowInstance: ReactFlowInstance,
  sourceId: string,
  data: ChatNodeData,
  observer: ResizeObserver,
) => {
  const currNode: TypeChatNode | undefined =
    reactFlowInstance.getNode(sourceId);
  if (!currNode) {
    return;
  }
  setTimeout(() => {
    const nodeElement = document.querySelectorAll(`[data-id="${sourceId}"]`)[0];
    let position: XYPosition;
    if (currNode) {
      const height = nodeElement.clientHeight;
      const width = nodeElement.clientWidth;
      position = {
        x: width / 2,
        y: (height ?? 0) + 20,
      };
    } else {
      position = {
        x: 0,
        y: 120,
      };
    }
    const newNode: TypeChatNode = {
      id: `chat-${uuid()}`,
      type: 'chat',
      dragHandle: '.drag-handle',
      position,
      parentNode: sourceId,
      data,
    };
    const edge: Edge =  {
      id: `e-${uuid()}`,
      source: sourceId,
      target: newNode.id,
      data: {},
    };
    reactFlowInstance.addNodes(newNode);
    // reactFlowInstance.addEdges(edge); // Disable follow up edge

    // increase z-index when first added so it shows up above existing nodes
    setTimeout(() => {
      const nodeElement = document.querySelectorAll(`[data-id="${newNode.id}"]`)[0];
      // @ts-ignore
      nodeElement.style.zIndex = '1';
    },300);

  }, 100);
};

export const createBrainstormNode = (
  reactFlowInstance: ReactFlowInstance,
  sourceId: string,
  data: BrainstormNodeData,
  isChild?: boolean,
) => {
  const currNode: TypeChatNode | undefined =
    reactFlowInstance.getNode(sourceId);
  if (!currNode) {
    return;
  }
  setTimeout(() => {
    let position: XYPosition;
    if (!isChild) {
      position = {
        // x: currNode.position.x + 670,
        x: currNode.position.x,
        y: (currNode.position.y ?? 0) + 120,
      };
    } else {
      position = {
        // x: (currNode.width ?? 0)/2 + 670,
        x: (currNode.width ?? 0)/2,
        y: 120,
      };
    }
    const newNode: TypeBrainstormNode = {
      id: `brainstorm-${uuid()}`,
      type: 'brainstorm',
      dragHandle: '.drag-handle',
      position,
      parentNode: isChild ? sourceId : undefined,
      data,
    };
    reactFlowInstance.addNodes(newNode);

      // add traveller edge
      const newEdge = createTopicNodeTravellerEdge(sourceId, newNode.id, false)
      reactFlowInstance.setEdges((edges) => edges.concat(newEdge));
  

    // increase z-index when first added so it shows up above existing nodes
    setTimeout(() => {
      const nodeElement = document.querySelectorAll(`[data-id="${newNode.id}"]`)[0];
      // @ts-ignore
      nodeElement.style.zIndex = '1';
    },300);

  }, 100);
};

export const createChatNodeFromDiv = (
  reactFlowInstance: ReactFlowInstance,
  event: MouseEvent,
  questionId: string,
  brainstormNodeId: string,
  data: ChatNodeData,
  questionIndex: number,
) => {

  setTimeout(() => {
    // const nodeElement = document.getElementById(questionId);
    // const nodeElement = document.querySelectorAll(`[data-id="${questionId}"]`)[0];
    
    // grab question div to get offset height to place generated chat node next to question
    const nodeElement = document.getElementById(questionId); 
    // grab brainstorm node to identify at what (x, y) coordinate to place generated chat node
    const brainstormNodeElement = reactFlowInstance.getNode(brainstormNodeId);
    const xy_position = brainstormNodeElement?.position!;
    const height = brainstormNodeElement?.height!;
    const width = brainstormNodeElement?.width!;
    const placementMethod = 'simple' // 'simple' - next to question | 'radial' - radial placement

    let position: XYPosition;
    position = {
      x: xy_position['x'] + width + 80, // place chat node on the right of brainstorm node
      y: xy_position['y'] + nodeElement?.offsetTop! - 10, // place chat node next to question div relative to brainstorm node (offsetTop)
    };

    if (placementMethod === 'simple') {
      console.log('simple placement');
      position = {
        x: xy_position['x'] + width + 80, // place chat node on the right of brainstorm node
        y: xy_position['y'] + nodeElement?.offsetTop! - 10, // place chat node next to question div relative to brainstorm node (offsetTop)
      };
    } else if (placementMethod === 'radial') {
      // place them radially 
      console.log('radial placement');
      const radius = 500;
      console.log('radius * Math.cos(map(questionIndex, 0, 12, 90, 0)', radius * Math.cos(map(questionIndex, 0, 12, 90, 0)));

      console.log('questionIndex', questionIndex);

      if (questionIndex <= 12) {
        const paddingX = radius * Math.cos(scale(questionIndex, [0, 12], [-70, 60]));
        const paddingY = radius * Math.sin(scale(questionIndex, [0, 12], [-70, 60]));
        console.log('paddingX', paddingX);
        console.log('paddingY', paddingY);
        console.log('map(questionIndex, 12, 0, 80, 0)', scale(questionIndex, [0, 12], [-70, 60]));
        console.log('map(questionIndex, 12, 0, 80, 0)', scale(questionIndex, [0, 12], [-70, 60]));
        position = {
          x: xy_position['x'] + ( width / 2 ) - (paddingX), 
          y: xy_position['y'] + ( height / 2) + (paddingY), 
        };
      } else {
        const paddingX = radius * Math.cos(scale(questionIndex, [13, 24], [0, -70]));
        const paddingY = radius * Math.sin(scale(questionIndex, [13, 24], [0, -70]));
        console.log('paddingX', paddingX);
        console.log('paddingY', paddingY);
        position = {
          x: xy_position['x'] + ( width ) + (paddingX), 
          y: xy_position['y'] + ( height) - (paddingY), 
        };
      }
      console.log('position', position);
    }


    const newNode: TypeChatNode = {
      id: `chat-${reactFlowInstance.getNodes().length}-${uuid()}`,
      type: "chat",
      dragHandle: ".drag-handle",
      position,
      data,
    };

    // const edge: Edge =  {
    //   type: 'default',
    //   id: `e-${reactFlowInstance.getEdges().length}-${uuid()}`,
    //   source: brainstormNodeId,
    //   target: newNode.id,
    //   data: {},
    // }

    reactFlowInstance.addNodes(newNode);

    const newEdge = createTravellerEdge(brainstormNodeId, newNode.id, false)
    reactFlowInstance.setEdges((edges) => edges.concat(newEdge));

    // increase z-index when first added so it shows up above existing nodes
    setTimeout(() => {
      const nodeElement = document.querySelectorAll(`[data-id="${newNode.id}"]`)[0];
      // @ts-ignore
      nodeElement.style.zIndex = '1';
    },300);

    // reactFlowInstance.addEdges(edge);
  }, 0);
};
